import React, { PropsWithChildren, useEffect, useRef, useState } from "react";
// import CorrectLine from "./correct-line";
import CorrectLine from "../../../static/assets/correct-line.png";

type TextCorrectionProps = {
  correctedText: string;
  correctedTextPosition: "topLeft" | "topRight" | "bottomLeft" | "bottomRight";
};

function getRandomDeg(): number {
  const random = Math.random();

  return random * 10 - 5;
}

const textPositionClassDesktop = {
  topLeft: "top-[-70%] left-[-50%]",
  topRight: "top-[-70%] right-[-50%]",
  bottomLeft: "bottom-[-70%] left-[-50%]",
  bottomRight: "bottom-[-70%] right-[-50%]",
};

const TextCorrection = ({
  children,
  correctedText,
  correctedTextPosition = "topLeft",
}: PropsWithChildren<TextCorrectionProps>) => {
  const correctedTextRef = useRef<HTMLDivElement>(null);
  const [horizontalPosition, setHorizontalPosition] = useState<number>();

  useEffect(() => {
    if (correctedTextRef.current) {
      const rect = correctedTextRef.current.getBoundingClientRect();

      let offset;
      if (rect.left < 16) {
        // left site - 16px padding
        offset = Math.abs(rect.left - 16);
      } else if (rect.right > window.innerWidth - 32) {
        // right site - 16px padding + 16px scrollbar width
        offset = window.innerWidth - 72 - rect.right;
      }
      !!offset && setHorizontalPosition(offset);
    }
  }, []);

  return (
    <div className="inline-block relative">
      <div
        ref={correctedTextRef}
        className={`absolute w-fit z-30 ${textPositionClassDesktop[correctedTextPosition]}`}
        style={{
          transform: horizontalPosition
            ? `translateX(${horizontalPosition}px)`
            : textPositionClassDesktop[correctedTextPosition],
        }}
      >
        <p className="text-[40px] tablet:text-[48px] reenie-beanie-regular text-brand">
          {correctedText}
        </p>
      </div>
      <div
        style={{ rotate: `${getRandomDeg()}deg` }}
        className="absolute z-20 top-[50%] left-0 w-full"
      >
        <img src={CorrectLine} alt="Przekreślony tekst" className="w-full" />
      </div>
      {children}
    </div>
  );
};

export default TextCorrection;
